import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Auth from 'services/Auth';

export default function PrivateRoute({ redirectUrl = '/login', children }) {
  const location = useLocation();

  return Auth.isAuthenticated() ? (
    children
  ) : (
    <Navigate to={redirectUrl} state={{ from: location }} replace />
  );
}
